export const buildRelatedPromoSelection = (option) => ({
  id: option.id,
  title: option.title,
  startDate: option.startDate ?? null,
  endDate: option.endDate ?? null,
  source: option.source ?? 'cashbox',
  brandId: option.brandId ?? null,
  label: option.label,
  status: option.status ?? null,
  statusLabel: option.statusLabel,
  dateRangeLabel: option.dateRangeLabel,
})

export default buildRelatedPromoSelection
